export const getDynamicYDomain = ([dataMin, dataMax]: [number, number]): [number, number] => {
  const padding = Math.max((dataMax - dataMin) * 0.1, 0.5);
  return [
    Math.floor((dataMin - padding) * 10) / 10,
    Math.ceil((dataMax + padding) * 10) / 10
  ];
};